import type { JsonObject } from 'main.core';

// @vue/component
export const KeyboardSeparator = {
	name: 'KeyboardSeparator',
	data(): JsonObject
	{
		return {};
	},
	template: `
		<div class="bx-im-keyboard-button__separator"></div>
	`,
};
